module.exports = __webpack_public_path__ + "img/mother-teresa.8a57355f.jpg";